import script from "./Item.vue?vue&type=script&setup=true&lang=js"
export * from "./Item.vue?vue&type=script&setup=true&lang=js"

import "./Item.vue?vue&type=style&index=0&id=d90bb810&scoped=true&lang=scss"

import exportComponent from "/Users/ilvinipitter/code/lider-fornecedores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d90bb810"]])

export default __exports__